import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffdd4142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "default" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "default-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "default-content-text" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Title"),
  /*#__PURE__*/_createElementVNode("p", null, "Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima numquam reprehenderit sapiente sint quidem. Dolore temporibus, repellendus atque aliquid laudantium harum odio. Dolores adipisci sunt saepe enim atque sint facilis!")
], -1))
const _hoisted_5 = { class: "default-content-image" }
const _hoisted_6 = { class: "default-content-image-wrapper" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: require(`../assets/903-1920x1080.jpg`),
              alt: "Banner Image"
            }, null, 8, _hoisted_7)
          ])
        ])
      ])
    ])
  ]))
}